import { FC } from 'react';

import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';
import { useUserQuery } from 'shared/store/serverSide/monolith-python/cian-api/site/v1/get-user-data-by-request/query';

import { VASBlock } from './VASBlock';

export const VASBlockContainer: FC = () => {
  const { data: user } = useUserQuery();
  const isShortListing = useListingLayoutIsShortSelector();

  return <VASBlock isAgentUser={!!user?.isAgent} isShortListing={isShortListing} />;
};
